<template>
  <div class="spacey-20">
    <div class="flex-row spacex-32">
      <BaseInfoColumn v-if="team.name" :title="$t('Company name')" :value="team.name" />
      <BaseInfoColumn
        v-if="team.registration_number"
        :title="$t('Reg. number')"
        :value="team.registration_number"
      />
      <BaseInfoColumn v-if="team.address" :title="$t('Company address')" :value="team.address" />
      <BaseInfoColumn
        v-if="team.currency"
        :title="$t('Default currency')"
        :value="currencyWithSymbol(team.currency)"
      />
    </div>

    <div class="spacey-12">
      <InputWithAction
        :placeholder="$t('Enter email to invite new teammate')"
        :button-text="$t('Invite new user')"
        :is-loading="loading"
        :error="error"
        :clear-field-trigger="clearFieldTrigger"
        @submit="submit"
      />
      <Spinner v-if="dataLoading" :size="30" />
      <div class="base-table spacey-12">
        <div class="table-header settings-tender-table-columns">
          <div class="text-sm grey-500">
            {{ $t('Teammate') }}
          </div>
          <div class="text-sm grey-500">
            {{ $t('Position') }}
          </div>
          <div class="text-sm grey-500 vertical-centering spacex-4">
            <span>{{ $t('Role') }}</span>
            <RolesTooltip />
          </div>
        </div>
        <UserInfoTableRow
          v-for="member in team.memberships"
          :key="member.user.id"
          :member="member"
          @reload="reload"
          @resend-invite="resendInvite"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Spinner from 'vue-simple-spinner';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import factory from '@/utils/api/factory';
  import parseError from '@/utils/formatting/parse-error';
  import t from '@/i18n';
  import BaseInfoColumn from '@/components/common/BaseInfoColumn';
  import InputWithAction from '@/components/ui/InputWithAction';
  import UserInfoTableRow from '@/containers/top-menu/header/profile-settings/team/UserInfoTableRow';
  import request from '@/utils/api/request';
  import RolesTooltip from '@/components/common/Tooltips/RolesTooltip';

  export default {
    name: 'TeamSettingsMembers',
    components: {
      RolesTooltip,
      UserInfoTableRow,
      InputWithAction,
      Spinner,
      BaseInfoColumn,
    },
    props: {
      dataLoading: Boolean,
      team: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        error: null,
        loading: false,
        clearFieldTrigger: false,
      };
    },
    computed: {
      ...mapState({
        activeCompany: (state) => state.auth.user?.membership,
      }),
      ...mapGetters('global', ['currencyWithSymbol']),
    },
    methods: {
      ...mapActions({
        setModalAction: 'modal/setModalAction',
      }),
      async submit(data) {
        this.error = null;
        this.loading = true;
        try {
          await factory('teams').postInResourcePath(this.activeCompany?.id, 'members', {
            email: data,
          });
          await this.$emit('refetch');
          this.clearFieldTrigger = !this.clearFieldTrigger;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
          this.error = parseError(e) || t('Something wrong happened');
        }
        this.loading = false;
      },
      async resendInvite(userId) {
        this.error = null;
        try {
          await request.post(`/teams/${this.activeCompany?.id}/members/${userId}/resend_invite/`);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
          this.error = parseError(e) || t('Something wrong happened');
        }
      },
      reload() {
        this.setModalAction({ type: 'projectsUpdated' });
        this.$emit('refetch');
      },
    },
  };
</script>
